
export enum Source {
  unknown = 0,
  solocate = 1,
  aman = 2
}

export function sourceStr2Num(str: string): number {
  switch (str.toLowerCase()) {
    case "unknown": {
      return 0;
    }
    case "solocate": {
      return 1;
    }
    case "aman": {
      return 2;
    }
  }
  return 0;
}

export var SourceTitles =
  [
    "Unknown",
    "Solocate",
    "Aman",
  ];

export var SourceKeys = Object.values(Source).filter(p => typeof Source[p] === "string");

export enum Hostility {
  Pending = 0,
  Unkn = 1,
  AssumedFriend = 2,
  Friend = 3,
  Neutral = 4,
  Suspect = 5,
  Hostile = 6,
}

export function hostilityStr2Num(str: string): number {
  switch (str.toLowerCase()) {
    case "pending": {
      return 0;
    }
    case "unknown": {
      return 1;
    }
    case "assm Frnd": {
      return 2;
    }
    case "friend": {
      return 3;
    }
    case "neutral": {
      return 4;
    }
    case "suspect": {
      return 5;
    }
    case "hostile": {
      return 6;
    }
  }
  return -1;
}

export var HostilityTitles =
  [
    "Pending",
    "Unknown",
    "Assm Frnd",
    "Friend",
    "Neutral",
    "Suspect",
    "Hostile",
  ];

export var HostilityKeys = Object.values(Hostility).filter(p => typeof Hostility[p] === "string");

export function HostilityTitle(identity: Hostility): string {
  let index = HostilityKeys.indexOf(identity);
  return HostilityTitles[index];
}

export enum NotificationSeverity {
  Error = 0,
  Warning = 1,
  Info = 2
}

export var NotificationSeverityTitles =
[
  "Error",
  "Warning",
  "Info"
]

export var NotificationSeverityKeys = Object.values(NotificationSeverity).filter(p => typeof NotificationSeverity[p] === "string");

export function NotificationSeverityTitle(identity: NotificationSeverity): string {
  let index = NotificationSeverityKeys.indexOf(identity);
  return NotificationSeverityTitle[index];
}


export enum IffStatus {
  NotInterrogatedNoStatement = 0,
  InterrogatedNoResponse = 1,
  InterrogatedInvalidResponse = 2,
  InterrogatedValidResponse = 3
}

var IffStatusTitles =
  [
    "",
    "No Resp",
    "Invalid",
    "Valid"
  ];

var IffStatusKeys = Object.values(IffStatus).filter(p => typeof IffStatus[p] === "string");

export function iffStatusTitle(iffStatus: IffStatus): string {
  let index = IffStatusKeys.indexOf(iffStatus);
  return IffStatusTitles[index];
}

export enum AirPltf {
  NoStatement = 0,
  Fighter = 1,
  FighterBomber = 2,
  Attack = 3,
  Bomber = 4,
  Reconnaissance = 5,
  Tanker_6 = 6,
  Tanker_7 = 7,
  Tanker_8 = 8,
  Interceptor = 9,
  Transport = 10,
  AirborneCommandPost = 11,
  MissileCarrier = 12,
  Missile = 13,
  ElecWarfare = 14,
  AntisubmarineWarfare = 15,
  AirborneEarlyWarnAndCtrl = 16,
  MaritimePatrolAircraft = 17,
  SearchAndRescue = 18,
  Drone = 19,
  RemotelyPilotedVehicle = 20,
  FixedWingGunship = 21,
  CivilAirliner = 22,
  CivilGeneral = 23,
  LighterThanAir = 24,
  Glider = 25,
  Decoy = 26,
  Helicopter = 27,
  AttackHelicopter = 28,
  HelicopterGunship = 29,
  AntisubmarineWarfareHelicopter = 30,
  MineWarfareHelicopter = 31,
  TransportHelicopter = 32,
  TacticalSupport = 33,
  Patrol = 34,
  MiscellaneousFixedWing = 35,
  MissileCtrlUnit = 36,
  SurfToAirMissile = 37,
  AirToSurfMissile = 38,
  SurfToSurfMissile = 39,
  Logistic = 40,
  AirToAirMissile = 41,
  SubsurfToSurfMissile = 42,
  SurfToSubsurfMissile = 43,
  CruiseMissile = 44,
  BallisticMissile = 45,
  AirborneLandSurveillance = 46,
  AirborneLaser = 47,
  UnmannedAerialVehicle = 48,
  ActiveElecDecoy = 49,
  InfraredDecoy = 50,
  ChaffDecoy = 51,
  ResetToNoStatement = 63
}

var AirPltfTitles =
  [
    "",
    "Fighter",
    "Fight Bomb",
    "Attack",
    "Bomber",
    "Recon",
    "Tank",
    "Tank Boom",
    "Tank Drogue",
    "Interceptor",
    "Transport",
    "ACP",
    "Carrier",
    "Missile",
    "EW",
    "ASW",
    "AEW",
    "MPA",
    "SAR",
    "Drone",
    "RPV",
    "Fx Wng Gun",
    "Civ Air",
    "Civ Gen",
    "LTA",
    "Glider",
    "Decoy",
    "Helo",
    "Atck Helo",
    "Helo Gun",
    "ASW Helo",
    "Mine Helo",
    "Trans Helo",
    "Tact Support",
    "Patrol",
    "Misc Fx Wng",
    "MCU",
    "SAM",
    "ASM",
    "SSM",
    "Logistic",
    "AAM",
    "Subs Surf Misl",
    "Surf Subs Misl",
    "Cruise Misl",
    "Balstc Misl",
    "Air Land Surv",
    "Air Laser",
    "Unmanned Aerial Vehicle (UAV)",
    "Active Electronic Decoy",
    "Infrared Decoy",
    "Chaff Decoy",
    "Reset To No Statement"
  ];

var AirPltfKeys = Object.values(AirPltf).filter(p => typeof AirPltf[p] === "string");

export function airPltfTitle(airPltf: AirPltf): string {
  let index = AirPltfKeys.indexOf(airPltf);
  return AirPltfTitles[index];
}

export enum PlotType {
  NONE = -1,
  SR = 0,
  SSR = 1,
  Combined = 2,
  JamStrobe = 3
}

var PlotTypeTitles =
  [
    "NONE",
    "SR",
    "SSR",
    "Combined",
    "JamStrobe"
  ];

var PlotTypeKeys = Object.values(PlotType).filter(p => typeof PlotType[p] === "string");

export function PlotTypeTitle(PlotType: PlotType): string {
  let index = PlotTypeKeys.indexOf(PlotType);
  return PlotTypeTitles[index];
}

export enum PlotCorr {
  NotRelevant = 0,
  Ambiguous = 1,
  Correlated = 2,
  UnCorrelated = 3,
  Tentative = 4
}

export const PlotCorrTitles =
  [
    "NotRelevant",
    "Ambiguous",
    "Correlated",
    "Uncorrelated",
    "Tentative"
  ];

var PlotCorrKeys = Object.values(PlotCorr).filter(p => typeof PlotCorr[p] === "string");

export function PlotCorrTitle(PlotCorr: PlotCorr): string {
  let index = PlotCorrKeys.indexOf(PlotCorr);
  return PlotCorrTitles[index];
}

export enum CoordinateType {
  WGS84_DMM = 0, // degrees, minutes, decimal minutes
  WGS84_DMS = 1, // degrees, minutes, seconds
  UTM = 2
}

var CoordinateTypeTitles =
  [
    "WGS84 DMM",
    "WGS84 DMS",
    "UTM"
  ];

var CoordinateTypeKeys = Object.values(CoordinateType).filter(p => typeof CoordinateType[p] === "string");

export function CoordinateTypeTitle(CoordinateType: CoordinateType): string {
  let index = CoordinateTypeKeys.indexOf(CoordinateType);
  return CoordinateTypeTitles[index];
}

export enum UserActionStatus {
  Fail = 0,
  Success = 1
}

export enum TrackType {
  Unidentified = 0,
  ABT = 1,
  TBM = 2
}

var TrackTypeTitles =
  [
    "Undefined",
    "ABT",
    "TBM"
  ];

var TrackTypeKeys = Object.values(TrackType).filter(p => typeof TrackType[p] === "string");

export function TrackTypeTitle(TrackType: TrackType): string {
  let index = TrackTypeKeys.indexOf(TrackType);
  return TrackTypeTitles[index];
}

export enum TrackStatus {
  Normal = 0,
  Lost = 1,
  Dropped = 2,
  Delete = 3
}

var TrackStatusTitles =
  [
    "Normal",
    "Lost",
    "Dropped",
    "Delete",
  ];

var TrackStatusKeys = Object.values(TrackStatus).filter(p => typeof TrackStatus[p] === "string");

export function TrackStatusTitle(TrackStatus: TrackStatus): string {
  let index = TrackStatusKeys.indexOf(TrackStatus);
  return TrackStatusTitles[index];
}


export enum ExtIpAction {
  Na = 0,
  Initiate = 1,
  Update = 2,
  Delete = 3,
  GetAll = 4
}

var ExtIpActionTitles =
  [
    "Na",
    "Initiate",
    "Update",
    "Delete",
    "GetAll"
  ];

var ExtIpActionKeys = Object.values(ExtIpAction).filter(p => typeof ExtIpAction[p] === "string");

export function ExtIpActionTitle(ExtIpAction: ExtIpAction): string {
  let index = ExtIpActionKeys.indexOf(ExtIpAction);
  return ExtIpActionTitles[index];
}

export enum Permission {
  ADMIN = 0,
  USER = 1
}

var PermissionTypeTitles =
  [
    "Admin",
    "User"
  ];

var PermissionTypeKeys = Object.values(Permission).filter(p => typeof Permission[p] === "string");

export function PermissionTypeTitle(Permission: Permission): string {
  let index = PermissionTypeKeys.indexOf(Permission);
  return PermissionTypeTitles[index];
}
